module.exports = __webpack_public_path__ + "static/img/M-700-MAJESTIC-WALNUT.f6b1a24.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/M-700-MAJESTIC-WALNUT.png
// module id = GF0g
// module chunks = 0